/* global modForm modUtils */
export function getHeapSessionIdCookieData() {
	let heapSessionSubmitCookie = null;
	let heapSessionId = null;
	let initialTimestamp;
	let expireInOneHour;
	let resultsPage = '';

	if (modUtils.heapCookie) {
		heapSessionId = modUtils.heapCookieData.sessionId;
		heapSessionSubmitCookie = modUtils.getCookie(heapSessionId);
	}

	if (heapSessionSubmitCookie !== null) {
		const cookieValue = JSON.parse(decodeURIComponent(heapSessionSubmitCookie));
		initialTimestamp = cookieValue.initialTimestamp;
		expireInOneHour = initialTimestamp + 1 * 60 * 60 * 1000;
		if (modForm.opts.isExclusiveMatch) {
			resultsPage = decodeURIComponent(cookieValue.resultsPage);
		} else {
			resultsPage = cookieValue.resultsPage;
		}
	}

	return { heapSessionSubmitCookie, heapSessionId, initialTimestamp, expireInOneHour, resultsPage};
}
